/**
 * Keys used for local storage operations throughout the application
 */
export enum StorageKeys {
  /** Key for the identity token */
  IDENTITY_TOKEN = 'IDENTITY_TOKEN'
}
